<template>
  <div class="p-confirm-email">
    <v-progress-circular
      v-if="loading"
      size="40"
      indeterminate
    ></v-progress-circular>
    <div v-if="!loading" class="p-confirm-email__title">{{ success ? $t('msg.mailConfirmed') : $t('msg.mailConfirmationError') }}</div>
    <c-btn
      v-if="!loading"
      class="mt-6"
      color="primary"
      :to="{name: 'login'}"
    >{{ $t('msg.continue') }}</c-btn>
  </div>
</template>

<script>
import CBtn from "@/components/ui/CBtn";

export default {
  components: {CBtn},
  data() {
    return {
      success: false,
      loading: false,
    };
  },
  created() {
    if (!!this.$route.query.id && !!this.$route.query.key) {
      this.loading = true;
      this.$store.dispatch('confirmEmail', {
        data: {
          id: parseInt(this.$route.query.id),
          key_reg: this.$route.query.key
        }
      })
        .then(() => {
          this.success = true;
        })
        .finally(() => this.loading = false);
    }
  }
}
</script>

<style lang="scss">
.p-confirm-email {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .p-confirm-email__title {
    font-size: 18px;
  }
}
</style>